import {
  getApiPaginationProd,
  getApiProd,
  postApiProd,
} from "services/mainService";

export const getListProjectModel = async (
  token,
  page = 1,
  limit = 10,
  status = [1, 2, 3],
  search
) => {
  try {
    const response = await getApiPaginationProd(
      `project/list`,
      {
        Authorization: `Bearer ${token}`,
      },
      {
        page,
        limit,
        list_status: JSON.stringify(status),
        search,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data?.map((item) => ({
          id: item.id,
          name: item.name,
          description: item.description,
          progress: item.progress,
          verifiedProgress: item.verifiedProgress,
          unread: item.unread,
          status: item.status,
          member: item.members,
          startDate: item.startDate,
          endDate: item.endDate,
        })),
        totalPage: response.totalPage,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "Get list project failed",
    };
  }
};

export const getListUnreadProjectModel = async (token) => {
  try {
    const response = await getApiProd(`project/unread/list`, {
      Authorization: `Bearer ${token}`,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,

        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "Get list project failed",
    };
  }
};
export const getProjectModel = async (token, id) => {
  try {
    const response = await getApiProd(
      `project/item`,
      {
        Authorization: `Bearer ${token}`,
      },
      {
        id,
      }
    );
    if (response.success)
      return {
        success: true,
        data: {
          id: response.data.id,
          name: response.data.name,
          owner: response.data.owner,
          description: response.data.description,
          progress: response.data.progress,
          verifiedProgress: response.data.verifiedProgress,
          status: response.data.status,
          files: response.data.files,
          unread: response.data.unread,
          tasks: response.data.tasks,
          members: response.data.members,
          comments: response.data.comments,
          startDate: response.data.startDate,
          endDate: response.data.endDate,
          logs: response.data.logs,
        },
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get project failed",
    };
  }
};
export const createProjectModel = async (
  token,
  name,
  description,
  member,
  files,
  startDate,
  endDate,
  progress
) => {
  try {
    const response = await postApiProd(
      `project/create`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        name,
        description,
        member,
        files,
        startDate,
        endDate,
        progress,
      }
    );

    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};
export const updateProjectModel = async (
  token,
  selectedTaskLevel,
  id,
  name,
  description,
  member,
  files,
  startDate,
  endDate,
  progress,
  tasks,
  verifiedProgress
) => {
  try {
    const response = await postApiProd(
      `project/update`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        tasks_id: selectedTaskLevel,
        id,
        name,
        description,
        member,
        files,
        startDate,
        endDate,
        progress,
        tasks,
        verified_progress: verifiedProgress,
      }
    );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  } catch (error) {
    return { success: false, message: error.message };
  }
};
export const deleteProjectModel = async (token, id) => {
  try {
    const response = await postApiProd(
      `project/delete`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
      }
    );

    if (response?.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const markAsReadProjectModel = async (token, id) => {
  try {
    const response = await postApiProd(
      `project/read`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "read project failed",
    };
  }
};

//COMENT

export const getCommentsModel = async (token, id, tasksId, page, limit) => {
  try {
    const response = await getApiPaginationProd(
      `project/comment/list`,
      {
        Authorization: `Bearer ${token}`,
      },
      {
        id,
        tasks_id: tasksId,
        page,
        limit,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data?.map((item) => ({
          id: item.id,
          projectId: item.projectId,
          tasksId: item.tasksId,
          files: item.files,
          members: item.members,
          comment: item.comment,
          reply: item.reply,
          status: item.status,
          resolveBy: item.resolveBy,
          date: item.date,
          user: item.user,
        })),
        total: response.total,
        totalPage: response.totalPage,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get project failed",
    };
  }
};
export const createCommentModel = async (
  token,
  projectId,
  projectName,
  tasksId,
  comment,
  members,
  files
) => {
  try {
    const response = await postApiProd(
      `project/comment/create`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        project_id: projectId,
        project_name: projectName,
        tasks_id: tasksId,
        comment,
        files,
        members,
      }
    );

    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const updateCommentModel = async (token, id, status) => {
  try {
    const response = await postApiProd(
      `project/comment/update`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
        status,
      }
    );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const deleteCommentModel = async (token, id) => {
  try {
    const response = await postApiProd(
      `project/comment/delete`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
      }
    );

    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const createReplyCommentModel = async (
  token,
  commentId,
  message,
  members,
  files
) => {
  try {
    const response = await postApiProd(
      `project/comment/reply`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        comment_id: commentId,
        reply: { reply: message, files, members },
      }
    );

    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

//LOGS
export const getLogsModel = async (token, id, tasksId, page, limit) => {
  try {
    const response = await getApiPaginationProd(
      `project/logs/list`,
      {
        Authorization: `Bearer ${token}`,
      },
      {
        id,
        tasks_id: tasksId,
        page,
        limit,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data?.map((item) => ({
          id: item.id,
          projectId: item.projectId,
          tasksId: item.tasksId,
          data: item.data,
          date: item.date,
        })),
        total: response.total,
        totalPage: response.totalPage,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get project failed",
    };
  }
};
